import React from 'react'

export const BrandGallery = () => {
  return (
    <div></div>
  )
}
